import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logo from "../../assets/images/CFE.png"
// import logoLightPng from "../../assets/images/logo-light.png"
// import logoLightSvg from "../../assets/images/favicon.ico"
// import logoDark from "../../assets/images/logo-dark.png"

// let logo = "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/ABC%202026%2FLogo%20(ABC).png?alt=media&token=a0603fb0-ca14-4c11-8a1b-343837e4ec34"
let logoLightSvg = "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/ABC%202026%2FLogo%20(ABC).png?alt=media&token=a0603fb0-ca14-4c11-8a1b-343837e4ec34"
// let logoDark = "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/image1%2Flogo-dark.png?alt=media"

function tAdd() {
  var body = document.body
  body.classList.add("vertical-collpsed")
  // body.classList.add("sidebar-enable")
}

const Sidebar = props => {
    useEffect(()=>{
      tAdd()
    },[])
  return (
    <React.Fragment>
      <div
        className="vertical-menu newnav" style={{position:"fixed"}}>
        <div className="navbar-brand-box">
          <Link to="#" className="logo logo-dark">
            <span className="logo-sm">
              <img loading="lazy"  src={logo} alt="" height="40" />
            </span>
            <span className="logo-lg">
              <img loading="lazy" src={logoLightSvg} alt="" height="70" />
            </span>
          </Link>

          <Link to="#" className="logo logo-light">
            <span className="logo-sm">
              <img loading="lazy" src={logo} alt="" height="40" />
            </span>
            <span className="logo-lg">
              <img loading="lazy" src={logoLightSvg} alt="" height="70" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
